
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/network/coverage",
      function () {
        return require("private-next-pages/network/coverage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/network/coverage"])
      });
    }
  